import {Outlet} from "react-router-dom";
import AdminLogContext from "../context/AdminDashboard/AdminLogContext";
import AdminLog from "../pages/AdminDashboard/AdminLog";
import React from "react";
import {ClientContextProvider} from "../pages/client/ClientContext";
import ClientsScreen from "../pages/client/ClientsScreen";
import {AdminContextProvider} from "../pages/admins/AdminsContext";
import AdminsScreen from "../pages/admins/AdminsScreen";
import {ClientDetailContextProvider} from "../pages/client-details/ClientDetailContext";
import ClientDetailScreen from "../pages/client-details/ClientDetailScreen";

export const userRoutes = {
    path: "user", element: <Outlet/>,
    children: [ {
        path: "admins", element: (
            <AdminContextProvider>
                <AdminsScreen/>
            </AdminContextProvider>
        )
    }, {
        path: "admins/log", element: (<AdminLogContext>
            <AdminLog/>
        </AdminLogContext>)
    }, {
        path: "clients", element: (
            <ClientContextProvider>
                <ClientsScreen/>
            </ClientContextProvider>
        )
    },
        {
            path: "clients/details", element: (
                <ClientDetailContextProvider>
                    <ClientDetailScreen/>
                </ClientDetailContextProvider>
            )
        },

    ]
}